import { brandEndpointIds } from 'root/src/shared/brand/brand.constants';
import { authenticationTypes } from 'root/src/shared/constants/auth';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
import { AuthGroup } from 'root/src/server/util/awsClients/authApiClient.types';
export const getBrandRetentionEndpoint = {
    [brandEndpointIds.GET_BRAND_RETENTION]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: [AuthGroup.Admin],
        payloadSchema: {
            type: 'object',
            properties: {
                brandName: {
                    type: 'string',
                },
                from: {
                    type: 'string',
                },
                to: {
                    type: 'string',
                },
            },
            required: [],
        },
        endpointType: otherEndpointType,
    },
};
